import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  Calendar,
  Users,
  UserPlus,
  FileText,
  CreditCard,
  BarChart3,
  LogOut,
  HelpCircle,
  Building2,
} from "lucide-react"; //  iconos más modernos
import "bootstrap/dist/css/bootstrap.min.css";
import SoporteModal from "./SoporteModal";
import "../App.css";

const Sidebar = () => {
  const location = useLocation();
  const [showSoporte, setShowSoporte] = useState(false);


  const menuItems = [
    {
      section: "Gestión",
      items: [
        { name: "Calendario", path: "/calendario", icon: <Calendar size={18} /> },
        { name: "Clientes", path: "/clientes", icon: <Users size={18} /> },
        { name: "Citas", path: "/citas", icon: <Calendar size={18} /> },
        { name: "Acompañantes", path: "/acompanantes", icon: <UserPlus size={18} /> },
        { name: "Pagos/Ticket", path: "/pagos", icon: <CreditCard size={18} /> },
        { name: "Generar", path: "/membrete", icon: <FileText size={18} /> },
        
      ],
    },
    {
      section: "Reportes",
      items: [
        { name: "Analisis Empresarial", path: "/exportar", icon: <BarChart3 size={18} /> },
        { name: "Alerta Deudores", path: "/empresas", icon: <Building2 size={18} /> },
      ],
    },
    {
      section: "Configuración",
      items: [
        /*{ name: "Ajustes", path: "/ajustes", icon: <Settings size={18} /> }*/
        {name: "Soporte", icon: <HelpCircle size={18} />, action: () => setShowSoporte(true), // Abre modal
        },
       /* { name: "Soporte", path: "/soporte", icon: <HelpCircle size={18} /> },*/
        { name: "Cerrar Sesión", path: "/logout", icon: <LogOut size={18} /> },
      ],
    },
  ];

  return (
    <div
      className="sidebar d-flex flex-column p-3"
      style={{
        width: "240px",
        minHeight: "100vh",
        background: "linear-gradient(180deg, #4e73df, #1cc88a)",
        color: "white",
      }}
    >
      {/* Logo */}
      <div className="text-center mb-4">
        <img
          src="logo_empresa.png"
          alt="Logo"
          style={{ height: "80px", borderRadius: "12px", background: "white", padding: "8px" }}
        />
      </div>

      {/* Menú con secciones */}
      {menuItems.map((group, index) => (
        <div key={index} className="mb-4">
          <small className="fw-semibold ms-2 text-uppercase" style={{ opacity: 0.8 }}>
            {group.section}
          </small>
          <div className="mt-2">
            {group.items.map((item) =>
              item.path ? (
                <Link
                  key={item.name}
                  to={item.path}
                  className={`d-flex align-items-center gap-2 mb-2 p-2 rounded text-decoration-none ${
                    location.pathname === item.path ? "active-link" : "inactive-link"
                  }`}
                  style={{ fontSize: "0.9rem", fontWeight: "500", transition: "all 0.2s ease-in-out" }}
                >
                  {item.icon}
                  <span>{item.name}</span>
                </Link>
              ) : (
                <button
                  key={item.name}
                  onClick={item.action}
                  className="d-flex align-items-center gap-2 mb-2 p-2 rounded btn btn-link text-white text-start"
                  style={{ fontSize: "0.9rem", fontWeight: "500" }}
                >
                  {item.icon}
                  <span>{item.name}</span>
                </button>
              )
            )}
          </div>
        </div>
      ))}

      {/* 🔹 Modal de soporte se coloca UNA sola vez al final del sidebar */}
      <SoporteModal show={showSoporte} handleClose={() => setShowSoporte(false)} />
    </div>
  );
};

export default Sidebar;
